import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { T, UI, FONT } from "../constants/tokens";
import { supabase } from "../lib/supabase";
import { modalScrim, modalPanel } from "./Modal";

// ─── One-time acknowledgement ────────────────────────────────────────────────
// Shown once to every registered user · at sign-up, and to existing users at
// their next sign-in · with a required checkbox (David, 2026-09-26). The date
// of the acknowledgement is stored on the user's own profile row
// (profiles.disclaimer_accepted_at, migrations/sprint11.sql).
//
// Until that SQL is run the column does not exist, and the window is NOT
// shown at all (David's decision): no local-only record that would have to be
// reconciled later. A guest is never asked · there is no account to record it on.

export const DISCLAIMER_TEXT =
  "המידע באפליקציה כללי, אינו מותאם אישית ואינו ייעוץ השקעות. הוא מבוסס על מקורות חיצוניים, ול-Suricata אין אינטרס בניירות המוצגים.";

export default function DisclaimerConsent({ userId, isGuest }) {
  const [need, setNeed] = useState(false);
  const [checked, setChecked] = useState(false);
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState(null);

  useEffect(() => {
    let alive = true;
    setNeed(false);
    if (!supabase || !userId || isGuest) return;
    supabase.from("profiles").select("disclaimer_accepted_at").eq("id", userId).maybeSingle()
      .then(({ data, error }) => {
        if (!alive) return;
        if (error) return;                          // column not there yet → not shown
        setNeed(!!data && !data.disclaimer_accepted_at);
      })
      .catch(() => {});
    return () => { alive = false; };
  }, [userId, isGuest]);

  if (!need) return null;

  const accept = async () => {
    if (!checked || saving) return;
    setSaving(true); setErr(null);
    const { error } = await supabase.from("profiles")
      .update({ disclaimer_accepted_at: new Date().toISOString() })
      .eq("id", userId);
    setSaving(false);
    if (error) { setErr("השמירה לא הצליחה · נסה שוב"); return; }
    setNeed(false);
  };

  return createPortal(
    <div role="dialog" aria-modal="true" aria-label="לפני שממשיכים" style={modalScrim(2000, { align: "center", padding: 16 })}>
      <div dir="rtl" style={{ ...modalPanel({ variant: "dialog", width: 460 }), display: "flex", flexDirection: "column", gap: 14 }}>
        <div style={{ fontSize: 19, fontWeight: 800, color: UI.text.primary, fontFamily: FONT.heading }}>לפני שממשיכים</div>
        <div style={{ fontSize: 15, color: UI.text.primary, lineHeight: 1.8 }}>{DISCLAIMER_TEXT}</div>
        <label style={{ display: "flex", alignItems: "flex-start", gap: 10, fontSize: 14.5, color: UI.text.primary, cursor: "pointer", minHeight: 44 }}>
          <input type="checkbox" checked={checked} onChange={e => setChecked(e.target.checked)}
            style={{ width: 20, height: 20, marginTop: 2, flexShrink: 0 }}/>
          קראתי והבנתי
        </label>
        {err && <div style={{ fontSize: 13, color: UI.caution }}>{err}</div>}
        <button onClick={accept} disabled={!checked || saving}
          style={{ minHeight: 48, borderRadius: T.radius.md, border: "none", fontSize: 15, fontWeight: 800, fontFamily: "inherit",
            background: checked ? UI.accent.base : UI.fill.subtle, color: checked ? UI.surface.page : UI.text.muted,
            cursor: checked ? "pointer" : "default" }}>
          {saving ? "שומר…" : "אישור"}
        </button>
      </div>
    </div>,
    document.body
  );
}
